import { Api } from 'api';
import { dateToFormat } from 'helpers/formatters/date';
import { useFormContext } from 'react-hook-form';

type Props = {
  fieldName: string;
  values?: any;
  setValues?: Function;
};

export const useCompositeWeightedTimeWindowData = ({
  fieldName,
  setValues,
  values,
}: Props) => {
  const { mutate, isLoading, data } =
    Api.benchmarks.GetCompositeWeightedTimeWindowData();
  const { getValues, trigger } = useFormContext();

  const refreshCompositeWeightedTimeWindowData = async () => {
    const triggerFields = [`${fieldName}.fromDate`];
    const isValid = await trigger(triggerFields);
    if (isValid) {
      const {
        assetSelectionSetId,
        fromDate = new Date(),
        tagRefPropertyDefinitionId,
        tagIds,
      } = getValues(fieldName);
      const currencyCode = getValues('baseCurrencyCode');
      if (
        assetSelectionSetId &&
        fromDate &&
        tagRefPropertyDefinitionId &&
        tagIds &&
        currencyCode
      ) {
        mutate({
          asOfDate: dateToFormat(new Date(fromDate), 'y-MM-d'),
          assetSelectionSetId,
          tagRefPropertyDefinitionId,
          currencyCode,
          tagIds: tagIds?.split(',')?.map((tag: string) => +tag),
        });
      }
    }
  };

  return {
    refreshCompositeWeightedTimeWindowData,
    isLoading,
    data,
  };
};
